"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ActionButton;

var _react = _interopRequireDefault(require("react"));

var _emotion = require("emotion");

var _isCompleted = _interopRequireDefault(require("../utils/isCompleted"));

var _DarkButton = _interopRequireDefault(require("../../Button/DarkButton"));

var _getProgress = _interopRequireDefault(require("../utils/getProgress"));

var s = {
  actionBtn:
  /*#__PURE__*/
  (0, _emotion.css)("padding-top:7px !important;height:28px;")
};

function ActionButton(props, key) {
  var completed = (0, _isCompleted.default)(props);
  var showStartButton = props.showStartButton,
      showSeeDetailsButton = props.showSeeDetailsButton;

  if (completed) {
    return null;
  }

  var isEnrolled = props.isEnrolled;

  if (!isEnrolled && !showStartButton) {
    var onEnroll = props.onEnroll,
        isEnrolling = props.isEnrolling;
    return _react.default.createElement(_DarkButton.default.SecondaryButton, {
      key: key,
      size: "small",
      onClick: onEnroll,
      disabled: isEnrolling,
      className: s.actionBtn
    }, "ENROLL");
  }

  var progress = (0, _getProgress.default)(props);

  if (progress > 0) {
    var onResume = props.onResume;
    return _react.default.createElement(_DarkButton.default.SecondaryButton, {
      key: key,
      size: "small",
      onClick: onResume,
      className: s.actionBtn
    }, "RESUME");
  }

  if (progress === 0 || showStartButton) {
    var onStartNow = props.onStartNow;
    return _react.default.createElement(_DarkButton.default.SecondaryButton, {
      key: key,
      size: "small",
      onClick: onStartNow,
      className: s.actionBtn
    }, showStartButton ? 'START' : 'START NOW');
  }

  if (showSeeDetailsButton) {
    var onSeeDetails = props.onSeeDetails;
    return _react.default.createElement(_DarkButton.default.SecondaryButton, {
      key: key,
      size: "small",
      onClick: onSeeDetails,
      className: s.actionBtn
    }, "See Details");
  }

  return null;
}